/* eslint-disable */
import { Table, DatePicker, Select, Flex, Radio, Button, message,Tooltip } from "antd";
import React, { forwardRef, useEffect, useState, useRef } from "react";
import commonFn from "@/utils/commonFn";
import { Typography } from "antd";
const { Text, Link } = Typography;
import http from "@/utils/http";
import api from "@/utils/api";
import { render } from "@testing-library/react";
import { SyncOutlined,InfoCircleOutlined } from "@ant-design/icons";
const { RangePicker } = DatePicker;

const MaintenceMain = forwardRef(() => {
  const [error, setError] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [tableoading, setTableLoading] = useState(false);
  const [selectedValues, setSelectedValues] = useState(null);
  const [reportList, setReportList] = useState([]);
  const originalReportList = useRef([]);
  const [currentReportList, setCurrentReportList] = useState(reportList);
  const [assignedDates, setAssignedDates] = useState([]);
  const [selectedSupervisor, setSelectedSupervisor] = useState(null);

  const handlQuotedCountClick = (record) => {
    // console.log(record);
    const quotedStatus = record.statusList?.find(
      (item) => item.statusName === "Quoted"
    );
    if (
      !quotedStatus ||
      quotedStatus.count === 0 ||
      quotedStatus.count === "0"
    ) {
      return;
    }
    const params = { ids: quotedStatus.maintenanceIdList.join(",") };
    const baseUrl = window.location.origin;
    const route = "/JobRequests/Maintenance";
    const paramString = new URLSearchParams(params).toString();
    const hash = `${route}${paramString ? `?${paramString}` : ""}`;
    const url = `${baseUrl}#${hash}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const handlRequestCountClick = (record) => {
    const quotedStatus = record.statusList?.find(
      (item) => item.statusName === "Assigned"
    );
    if (
      !quotedStatus ||
      quotedStatus.count === 0 ||
      quotedStatus.count === "0"
    ) {
      return;
    }
    const params = { ids: quotedStatus.maintenanceIdList.join(",") };
    const baseUrl = window.location.origin;
    const route = "/JobRequests/Maintenance";
    const paramString = new URLSearchParams(params).toString();
    const hash = `${route}${paramString ? `?${paramString}` : ""}`;
    const url = `${baseUrl}#${hash}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const handlSupervisorClick = (record) => {
    const quotedStatus = record.statusList?.find(
      (item) => item.statusName === "Total Requests Under Supervisor"
    );
    if (
      !quotedStatus ||
      quotedStatus.count === 0 ||
      quotedStatus.count === "0"
    ) {
      return;
    }
    const params = { ids: quotedStatus.maintenanceIdList.join(",") };
    const baseUrl = window.location.origin;
    const route = "/JobRequests/Maintenance";
    const paramString = new URLSearchParams(params).toString();
    const hash = `${route}${paramString ? `?${paramString}` : ""}`;
    const url = `${baseUrl}#${hash}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const handlRequestOutstandingClick = (record) => {
    const quotedStatus = record.statusList?.find(
      (item) => item.statusName === "Total Outstanding Requests"
    );
    if (
      !quotedStatus ||
      quotedStatus.count === 0 ||
      quotedStatus.count === "0"
    ) {
      return;
    }
    const params = { ids: quotedStatus.maintenanceIdList.join(",") };
    const baseUrl = window.location.origin;
    const route = "/JobRequests/Maintenance";
    const paramString = new URLSearchParams(params).toString();
    const hash = `${route}${paramString ? `?${paramString}` : ""}`;
    const url = `${baseUrl}#${hash}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };
  const handleRequestOutstandingClick = (record) => {
    const quotedStatus = record.statusList?.find(
      (item) => item.statusName === "1-15 Days (Total)"
    );
    if (
      !quotedStatus ||
      quotedStatus.count === 0 ||
      quotedStatus.count === "0"
    ) {
      return;
    }
    const params = { ids: quotedStatus.maintenanceIdList.join(",") };
    const baseUrl = window.location.origin;
    const route = "/JobRequests/Maintenance";
    const paramString = new URLSearchParams(params).toString();
    const hash = `${route}${paramString ? `?${paramString}` : ""}`;
    const url = `${baseUrl}#${hash}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const handleRequest16Click = (record) => {
   const quotedStatus = record.statusList?.find(
      (item) => item.statusName === "16-30 Days (Total)"
    );
    if (
      !quotedStatus ||
      quotedStatus.count === 0 ||
      quotedStatus.count === "0"
    ) {
      return;
    }
    const params = { ids: quotedStatus.maintenanceIdList.join(",") };
    const baseUrl = window.location.origin;
    const route = "/JobRequests/Maintenance";
    const paramString = new URLSearchParams(params).toString();
    const hash = `${route}${paramString ? `?${paramString}` : ""}`;
    const url = `${baseUrl}#${hash}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };
  const handlCompletedJobClick = (record) => {
    const quotedStatus = record.statusList?.find(
      (item) => item.statusName === "Total Completed Job"
    );
    if (
      !quotedStatus ||
      quotedStatus.count === 0 ||
      quotedStatus.count === "0"
    ) {
      return;
    }
    const params = { ids: quotedStatus.maintenanceIdList.join(",") };
    const baseUrl = window.location.origin;
  const route = "/JobRequests/MaintenanceHistory";
    const paramString = new URLSearchParams(params).toString();
    const hash = `${route}${paramString ? `?${paramString}` : ""}`;
    const url = `${baseUrl}#${hash}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };
  //
  const handlOTClick = (record) => {
    const quotedStatus = record.statusList?.find(
      (item) => item.statusName === "Older OT"
    );
    if (
      !quotedStatus ||
      quotedStatus.count === 0 ||
      quotedStatus.count === "0"
    ) {
      return;
    }
    const params = { ids: quotedStatus.maintenanceIdList.join(",") };
    const baseUrl = window.location.origin;
      const route = "/JobRequests/Maintenance";
    const paramString = new URLSearchParams(params).toString();
    const hash = `${route}${paramString ? `?${paramString}` : ""}`;
    const url = `${baseUrl}#${hash}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const handlCompletedNoInvoicedCountClick = (record) => {
    const quotedStatus = record.statusList?.find(
      (item) => item.statusName === "Completed No Invoiced"
    );
    if (
      !quotedStatus ||
      quotedStatus.count === 0 ||
      quotedStatus.count === "0"
    ) {
      return;
    }
    const params = { ids: quotedStatus.maintenanceIdList.join(",") };
    const baseUrl = window.location.origin;
    const route = "/JobRequests/MaintenanceHistory";
    const paramString = new URLSearchParams(params).toString();
    const hash = `${route}${paramString ? `?${paramString}` : ""}`;
    const url = `${baseUrl}#${hash}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };
  // 转义
  const formatCount = (count) => {
    if (count === null || count === undefined) return "-";
    return Number(count) === 0 ? "-" : count;
  };
  // 通用函数处理

  const initColumns = [
    {
      title: "Supervisor Name",
      dataIndex: "accountName",
      key: "accountName",
      hidden: false,
      width: 200,
      align: "center",
      isSorter: true,
      sortterMultiple: 2,
      render: (text, record) => ({
        children: record.isSummaryRow ? (
          <strong style={{ fontSize: "16px" }}>{text}</strong>
        ) : (
          text
        ),
        props: {
          rowSpan: record.isFirstRow ? record.rowSpan : 0,
        },
      }),
    },

    {
      title: "Vendor Name",
      dataIndex: "vendorName",
      key: "vendorName",
      hidden: false,
      width: 200,
      align: "center",
      isSorter: true,
      sortterMultiple: 2,
      render: (text, record) => ({
        children:
          record.vendorName === "Grand Total" ? (
            <strong style={{ fontSize: "16px" }}>{text}</strong>
          ) : record.vendorName === "Total" ? (
            <strong>{text}</strong>
          ) : (
            text
          ),
      }),
    },
    {
      title: "Total Outstanding Requests",
      dataIndex: "Total Outstanding Requests",
      key: "Total Outstanding Requests",
      hidden: false,
      width: 100,
      align: "center",
      render: (_, record) => {
        const status = record.statusList?.find(
          (s) => s.statusName === "Total Outstanding Requests"
        );
        const value = formatCount(status?.count);
        return (
          <span
            style={{
              color: value === "-" ? "inherit" : "#0e78a9",
              cursor: value === "-" ? "default" : "pointer",
            }}
            onClick={() =>
              value !== "-" && handlRequestOutstandingClick(record)
            }
          >
            {value}
          </span>
        );
      },
    },


{
  title: (
    <>
      1-15 Days{" "}
      <Tooltip title="Assigned - Complete = Not Complete">
        <InfoCircleOutlined style={{ marginLeft: 4, color: "#999" }} />
      </Tooltip>
    </>
  ),
  dataIndex: '1-15 Days (Total)',
  key: '1-15 Days (Total)',
  align: 'center',
  render: (_, record) => {
    const assigned = record.statusList.find(item => item.statusName === '1-15 Days (Total)');
    const completed = record.statusList.find(item => item.statusName === '1-15 Days (Completed)');
    
    const assignedCount = parseInt(assigned?.count || 0);
    const completedCount = parseInt(completed?.count || 0);
    const outstandingCount = assignedCount - completedCount;
    
    // 检查所有计数是否为0
    if (assignedCount === 0 && completedCount === 0 && outstandingCount === 0) {
      return '-';
    }
    
    return (
      <>
        {assignedCount} - {completedCount} ={' '}
        <span
          style={{
            color: outstandingCount === 0 ? "inherit" : "#0e78a9",
            cursor: outstandingCount === 0 ? "default" : "pointer",
          }}
          onClick={() => outstandingCount !== 0 && handleRequestOutstandingClick(record)}
        >
          {outstandingCount}
        </span>
      </>
    );
  },
},
{
  title: (
    <>
      16-30 Days{" "}
      <Tooltip title="Assigned - Complete = Not Complete">
        <InfoCircleOutlined style={{ marginLeft: 4, color: "#999" }} />
      </Tooltip>
    </>
  ),
  dataIndex: '16-30 Days (Total)',
  key: '16-30 Days (Total)',
  align: 'center',
  render: (_, record) => {
    const assigned = record.statusList.find(item => item.statusName === '16-30 Days (Total)');
    const completed = record.statusList.find(item => item.statusName === '16-30 Days (Completed)');
    
    const assignedCount = parseInt(assigned?.count || 0);
    const completedCount = parseInt(completed?.count || 0);
    const outstandingCount = assignedCount - completedCount;
    
    // 检查所有计数是否为0
    if (assignedCount === 0 && completedCount === 0 && outstandingCount === 0) {
      return '-';
    }
    
    return (
      <>
        {assignedCount} - {completedCount} ={' '}
        <span
          style={{
            color: outstandingCount === 0 ? "inherit" : "#0e78a9",
            cursor: outstandingCount === 0 ? "default" : "pointer",
          }}
          onClick={() => outstandingCount !== 0 && handleRequest16Click(record)}
        >
          {outstandingCount}
        </span>
      </>
    );
  },
},
    {
      title: "Older OT",
      dataIndex: "Older OT",
      key: "Older OT",
      hidden: false,
      width: 100,
      align: "center",
      isSorter: true,
      sortterMultiple: 2,
         render: (_, record) => {
        const status = record.statusList?.find(
          (s) => s.statusName === "Older OT"
        );
        const value = formatCount(status?.count);
        return (
          <span
            style={{
              color: value === "-" ? "inherit" : "#0e78a9",
              cursor: value === "-" ? "default" : "pointer",
            }}
            onClick={() => value !== "-" && handlOTClick(record)}
          >
            {value}
          </span>
        );
      },
    },
    {
      title: "Total Completed Jobs",
      dataIndex: "Total Completed Job",
      key: "Total Completed Job",
      hidden: false,
      width: 100,
      align: "center",
      isSorter: true,
      sortterMultiple: 2,
      render: (_, record) => {
        const status = record.statusList?.find(
          (s) => s.statusName === "Total Completed Job"
        );
        const value = formatCount(status?.count);
           return (
          <span
            style={{
              color: value === "-" ? "inherit" : "#0e78a9",
              cursor: value === "-" ? "default" : "pointer",
            }}
            onClick={() => value !== "-" && handlCompletedJobClick(record)}
          >
            {value}
          </span>
        );
      },
    },
    {
      title: "Vendor Phone",
      dataIndex: "Vendor Phone #",
      key: "Vendor Phone #",
      hidden: false,
      width: 100,
      align: "center",
      isSorter: true,
      sortterMultiple: 2,
      render: (_, record) => {
        const status = record.statusList?.find(
          (s) => s.statusName === "Vendor Phone #"
        );
        const value = formatCount(status?.count);
        return (
          <span
            // style={{
            //   color: value === "-" ? "inherit" : "#0e78a9",
            //   cursor: value === "-" ? "default" : "pointer",
            // }}
            // onClick={() => value !== "-" && handlCompletedCountClick(record)}
          >
            {value}
          </span>
        );
      },
    },
  ];
  const [columns, setColumns] = useState(commonFn.handleColunmFn(initColumns));

  // 获取所有的report

  const reportAllData = async (accountIds) => {
    try {
      setTableLoading(true);
      const params = {
        accountIdList: Array.isArray(accountIds)
          ? accountIds.join(",")
          : accountIds || "",
      };
      const queryString = new URLSearchParams(params).toString();
      const url = `${api.getMaintenanceVendorDaysReport}?${queryString}`;
      const response = await http.get(url);

      let flattenedData = [];
      response.data?.forEach((supervisor) => {
        const isAllSupervisor = supervisor.accountName === "All Supervisor";
        // 处理 All Supervisor 行（不合并）
        if (isAllSupervisor) {
          supervisor.vendorReports.forEach((vendor) => {
            flattenedData.push({
              ...supervisor,
              ...vendor,
              isFirstRow: true,
              rowSpan: 1,
              isSummaryRow: true, // 标记为汇总行
              key: `summary-${vendor.vendorName || Date.now()}`,
            });
          });
        }
        // 处理其他 supervisor 数据
        else {
          const validVendors = supervisor.vendorReports.filter(
            (v) => v.vendorName !== "Grand Total"
          );

          // 添加常规 vendor 数据（合并 accountName）
          validVendors.forEach((vendor, index) => {
            flattenedData.push({
              ...supervisor,
              ...vendor,
              isFirstRow: index === 0,
              rowSpan: index === 0 ? validVendors.length : 0,
              isSummaryRow: false,
              key: `${supervisor.accountId}-${vendor.vendorName || index}`,
            });
          });
        }
      });

      setFilteredData(flattenedData);
    } catch (err) {
      console.error("请求失败:", err);
      setError(err);
    } finally {
      setTableLoading(false);
    }
  };

  // 下拉选择
  const onSupervisorChange = (value) => {
    setSelectedSupervisor(value);
  };
  // submit
  const handleSubmit = async () => {

    const params = {
      accountIdList: selectedSupervisor,
    };
    console.log("提交参数:", params);
    try {
      setTableLoading(true);
      setFilteredData([]);  //清空 表格数据
      const queryString = new URLSearchParams(params).toString();
      const url = `${api.getMaintenanceVendorDaysReport}?${queryString}`;
      const response = await http.get(url);
      let flattenedData = [];
      response.data?.forEach((supervisor) => {
        const isAllSupervisor = supervisor.accountName === "All Supervisor";
        // 处理 All Supervisor 行（不合并）
        if (isAllSupervisor) {
          supervisor.vendorReports.forEach((vendor) => {
            flattenedData.push({
              ...supervisor,
              ...vendor,
              isFirstRow: true,
              rowSpan: 1,
              isSummaryRow: true, // 标记为汇总行
              key: `summary-${vendor.vendorName || Date.now()}`,
            });
          });
        }
        // 处理其他 supervisor 数据
        else {
          const validVendors = supervisor.vendorReports.filter(
            (v) => v.vendorName !== "Grand Total"
          );

          // 添加常规 vendor 数据（合并 accountName）
          validVendors.forEach((vendor, index) => {
            flattenedData.push({
              ...supervisor,
              ...vendor,
              isFirstRow: index === 0,
              rowSpan: index === 0 ? validVendors.length : 0,
              isSummaryRow: false,
              key: `${supervisor.accountId}-${vendor.vendorName || index}`,
            });
          });
        }
      });

      setFilteredData(flattenedData);
    } catch (err) {
      console.error("请求失败:", err);
      setError(err);
    } finally {
      setTableLoading(false);
    }
  };
  const getSupervisorList = async () => {
    try {
      const response = await http.get(api.getSupervisorList);
      console.log("response", response);
      if (response.code === "1") {
        const options = [
          { value: "", label: "All" },
          ...response.data.map((item) => ({
            value: item.accountId,
            label: item.fullName,
          })),
        ];
        setReportList(options);
        originalReportList.current = options;
        setCurrentReportList(options);
      }
    } catch (err) {
      console.error("请求失败:", err);
      setError(err);
    }
  };
  const showModalThree = () => {
    console.log("==========刷新按钮============");
    reportAllData();
    setSelectedValues([]);
  };
  // 初始化函数

  useEffect(() => {
    // reportAllData()
    getSupervisorList();
  }, []);
  return (
    <div>

      <Flex className="topDiv" justify="space-between" align="center">
        {/* 左边筛选条件 */}
        <Flex align="center" gap={12}>
          <div>
            <span style={{ marginRight: 8 }}>Supervisor:</span>
            <Select
              mode="multiple"
              showSearch
              allowClear
              placeholder="Select a supervisor"
              value={selectedSupervisor}
              onChange={onSupervisorChange}
              style={{ width: 380,textAlign: "left"}}
              options={currentReportList}
              className="supervisor-select"
            />
          </div>

          <Button type="primary" onClick={handleSubmit}>
            Submit
          </Button>
        </Flex>

        {/* 右边刷新按钮 */}
        <Radio.Group defaultValue="a" size="middle">
          <Radio.Button value="a" onClick={showModalThree}>
            <SyncOutlined />
          </Radio.Button>
        </Radio.Group>
      </Flex>
      <Table
        rowClassName="table-row-gradient"
        loading={tableoading}
        bordered={true}
        columns={columns.filter((col) => col.hidden === false)}
        dataSource={[...filteredData]}
        pagination={false}
        rowKey="accountId"
        scroll={{
          x: "max-content",
          y: "calc(100vh - 350px)",
        }}
        className="maintenance-report-Table"
      />
    </div>
  );
});
export default MaintenceMain;
